<script>
export default {
	props: {
		contactos: {
			type: Array,
			required: true
		}
	},

	methods: {
		// favoriteToggle(contactos) {
		// 	contactos.favorito = !contactos.favorito;
		// },
		contactoSeleccionado(contacto) {
			this.$emit('contactoSeleccionado', contacto);
		}
	}
}
</script>
<template>
	<ul class="list-group list-group-flush overflow-contacto">
		<li
			v-for="contacto in contactos" :key="contacto.id"
			class="list-group-item list-group-item-action">
			<div class="d-flex">
				<div class="flex-grow-1">
					<a 
						href="javascript:"
						@click="contactoSeleccionado(contacto)"
						class="d-flex align-items-center list-contactos-action">
						<div class="flex-shrink-0">
							<img 
								v-if="contacto.imagen_perfil"
								width="48"
								height="48"
								class="img-object-cover rounded-circle"
								:src="contacto.imagen_perfil"
								:alt="contacto | userFullName | initials"
							>
							<img 
								v-if="!contacto.imagen_perfil"
								width="48"
								height="48"
								class="img-object-cover rounded-circle"
								src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
							>
						</div>
						<div class="flex-grow-1 ms-3">
							<p class="d-grid text-secondary mb-0">
								<strong class="ellipsis-custom">
								{{ contacto | userFullName }}
								</strong>
								<span class="text-secondary text-opacity-75 ellipsis-custom">
									{{ contacto.cargo[0]?.nombre_cargo | capitalizeFirstChars }}
								</span>
							</p>
						</div>
					</a>
				</div>
			</div>
		</li>
	</ul>
</template>